import anime from "animejs";
import clsx from "clsx";
import format from "date-fns/format";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";

import ColumnEditorContainer from "../../containers/matrix/ColumnEditorContainer";
import ItemEditorChibaContainer from "../../containers/matrix/ItemEditorChibaContainer";
import ItemEditorContainer from "../../containers/matrix/ItemEditorContainer";
import MiddleClassEditorContainer from "../../containers/matrix/MiddleClassEditorContainer";
import ProtectionBundleEditorContainer from "../../containers/matrix/ProtectionBundleEditorContainer";
import PulldownExportContainer from "../../containers/matrix/PulldownExportContainer";
import RightGridHeaderContainer from "../../containers/matrix/RightGridHeaderContainer";
import SearchPanelContainer from "../../containers/matrix/SearchPanelContainer";
import SpecialProcessBundleEditorContainer from "../../containers/matrix/SpecialProcessBundleEditorContainer";
import TaskEditorContainer from "../../containers/matrix/TaskEditorContainer";
import TooltipContainer from "../../containers/matrix/TooltipContainer";
import WorkEditorContainer from "../../containers/matrix/WorkEditorContainer";
import * as commonUtil from "../../lib/common";
import { isValid, isValidRole } from "../../lib/roleChecker";
import storageManager from "../../lib/storageManager";
import Modal from "../Modal";
import StatusSwitcher from "../common/StatusSwitcher";

import Help from "./Help";
import LeftGridBody from "./LeftGridBody";
import LeftGridHeader from "./LeftGridHeader";
import LeftGridHeaderChiba from "./LeftGridHeaderChiba";
import RightGridBody from "./RightGridBody";

import ConfirmDialog from "@/components/ConfirmDialog";
import { Spacer } from "@/components/common";
import { FooterPager } from "@/components/common/FooterPager";
import { SettingIconButton } from "@/components/common/SettingIconButton";
import DownloadScheduleModal from "@/components/matrix/DownloadScheduleModal";
import ExtraRequestModal from "@/components/matrix/ExtraRequestModal";
import { MatrixScreenConfigModal } from "@/components/matrix/MatrixScreenConfigModal";
import { LockColumnEditor } from "@/components/matrix/Modal/LockColumnEditor";
import PulldownStatus from "@/components/matrix/PulldownStatus";
import { SegmentSettingModal } from "@/components/matrix/SegmentSettingModal";
import SortEditor from "@/components/matrix/SortEditor";
import WorkCreateEditorContainer from "@/containers/matrix/WorkCreateEditorContainer";
import { calculateCurrentPage, calculateStartPos, getPageFromQueryParam } from "@/lib/pager";
import restoreState from "@/lib/restoreState";
import { replaceQueryParams } from "@/lib/urlHelper";
import { MatrixSearchParams } from "@/models/matrix";
import { TaskScheduleType, TaskSwitcherStatus } from "@/models/tasks";

class Matrix extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSearchPanel: this.isInitialView(),
      activeButton: "",
      openDownloadScheduleModal: false,
      showMiddleClassEditor: false,
      showColumnEditor: false,
      showTaskEditor: false,
      showItemEditor: false,
      showCreateWorkEditor: false,
      showSortEditor: false,
      showWorkEditor: false,
      showColumnDeleteDialog: false,
      deleteProcess: null,
      showColumnLockDialog: false,
      lockProcess: null,
      showApprovalEditor: false,
      showSpecialBundleEditor: false,
      showProtectBundleEditor: false,
      showHelp: false,
      limit: 20,
      start: 1,
      end: false,
      editingProcessMiddleClassId: 0,
      editingProcessMiddleClassIndex: 0,
      editingProcessId: 0,
      editingItemId: 0,
      editingTaskId: 0,
      sortItemId: 0,
      tooltip: null,
      tooltipChiba: null,
      downloadUrl: "",
      downloadName: "",
      validRequired: false,
      initialSearched: false,
      offset: 0,
      maxLength: 60,
      showStatusBulkUpdate: false,
      statusBulkUpdateValue: null,
      statusBulkUpdateNum: null,
      loadingTaskUpdate: false,
      scheduleType: null,
      bundleParams: [],
      currentPage: 1,
      totalNum: 0,
      maxPage: 0,
      requestParam: null,
      tmpLimit: 20,
      startPos: 1,
      isStatus: false,
      headerMessage: "",
      processIdSplitScheduleModal: null,
      showScreenConfigModal: false,
      showExtraRequestModal: false,
      extraRequestTitle: "",
      extraRequestProcessTitle: "",
      extraRequestTaskId: null as number | null,
      init: false,
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.showWorkEditor = this.showWorkEditor.bind(this);
    this.showCreateWorkEditor = this.showCreateWorkEditor.bind(this);
    this.setTooltip = this.setTooltip.bind(this);
    this.setTooltipChiba = this.setTooltipChiba.bind(this);
    this.download = this.download.bind(this);
    this.showSearchPanel = this.showSearchPanel.bind(this);
    this.isInitialView = this.isInitialView.bind(this);
    this.clearSubmenu = this.clearSubmenu.bind(this);
    this.handleHashChange = this.handleHashChange.bind(this);
    this.showStatusBulkUpdatePanel = this.showStatusBulkUpdatePanel.bind(this);
    this.fetchStatusUpdateNum = this.fetchStatusUpdateNum.bind(this);
    this.closeStatusBulkUpdatePanel = this.closeStatusBulkUpdatePanel.bind(this);
    this.handleBulkUpdate = this.handleBulkUpdate.bind(this);
    this.showSpecialProcessBundle = this.showSpecialProcessBundle.bind(this);
    this.hideSpecialProcessBundle = this.hideSpecialProcessBundle.bind(this);
    this.showProtectionBundle = this.showProtectionBundle.bind(this);
    this.hideProtectionBundle = this.hideProtectionBundle.bind(this);
    this.handleClickAddColumnContextMenu = this.handleClickAddColumnContextMenu.bind(this);
    this.handleClickDeleteColumnContextMenu = this.handleClickDeleteColumnContextMenu.bind(this);
    this.handleClickLockColumnContextMenu = this.handleClickLockColumnContextMenu.bind(this);
    this.handleClickUnlockColumnContextMenu = this.handleClickUnlockColumnContextMenu.bind(this);
    this.handleClickContextMenu = this.handleClickContextMenu.bind(this);
    this.handleClickReceiverContextMenu = this.handleClickReceiverContextMenu.bind(this);
    this.handleClickSplitScheduleContextMenu = this.handleClickSplitScheduleContextMenu.bind(this);
    this.showDownloadScheduleModal = this.showDownloadScheduleModal.bind(this);
    this.hideDownloadScheduleModal = this.hideDownloadScheduleModal.bind(this);
    this.openScreenConfigModal = this.openScreenConfigModal.bind(this);
    this.hideScreenConfigModal = this.hideScreenConfigModal.bind(this);
    this.handleCopyItem = this.handleCopyItem.bind(this);
    this.handleDeleteItem = this.handleDeleteItem.bind(this);
    this.handleItemBulkOff = this.handleItemBulkOff.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(this.state.showTaskEditor && nextState.showTaskEditor);
  }

  componentDidMount() {
    this.props.fetchMatrixColumnConfig();
    // 予定表の項目情報を取得する
    this.props.getScheduleFields();

    if (this.isInitialView()) {
      return;
    }

    this.props.changeSwitcherStatus(-1);

    if (localStorage.getItem("limit")) {
      this.setState({ limit: parseInt(localStorage.getItem("limit")) });
    }
    // AM1:00〜5:00に予定未確定のメッセージを表示する
    const now = new Date();
    if (1 <= now.getHours() && now.getHours() < 5) {
      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      this.setState({ headerMessage: format(tomorrow, this.props.t("schedule_is_not_confirmed")) });
    }

    // 件名のコンテキストメニュー表示制御
    window.addEventListener("click", this.clearSubmenu);
    window.addEventListener("hashchange", this.handleHashChange);
  }

  componentWillUnmount() {
    this.props.revertLocalCondition();
    this.props.initializeMatrix();
    window.removeEventListener("hashchange", this.handleHashChange);

    window.removeEventListener("click", this.clearSubmenu);
  }

  componentDidUpdate(prevProps) {
    const { validRequired } = this.props;
    if (typeof validRequired === "undefined") {
      return;
    }
    if (!this.state.init && validRequired && this.props.configHideInvalidRows !== null) {
      // 検索条件の復元が完了している、かつ、表示設定取得済みの場合に前回の条件で検索する
      this.setState({ init: true });
      this.handleSearch({ p: getPageFromQueryParam("p") });
    }
    if (typeof prevProps.validRequired === "undefined" && !validRequired) {
      this.showSearchPanel();
    }
    const isGridDisplayed = this.rightHeaderContainer && this.rightBodyContainer;
    if (this.props.dragScroll?.startsWith("left") && isGridDisplayed) {
      const toLeft = this.rightHeaderContainer.scrollLeft - 60;
      this.rightHeaderContainer.scrollLeft = toLeft;
      this.rightBodyContainer.scrollLeft = toLeft;
    }
    if (this.props.dragScroll?.startsWith("right") && isGridDisplayed) {
      const toRight = this.rightHeaderContainer.scrollLeft + 60;
      this.rightHeaderContainer.scrollLeft = toRight;
      this.rightBodyContainer.scrollLeft = toRight;
    }

    // TODO: 各画面ではなく親で工事が変わったらfetchするようにする
    if (prevProps.constructionId !== this.props.constructionId) {
      // 予定表の項目情報を取得する
      this.props.getScheduleFields();
    }
  }

  isInitialView() {
    const urlState = restoreState();

    if (this.props.inheritingSearchConditions || urlState.item_id) {
      return false;
    }

    return storageManager.getConstructionItem("matrixSearchParams") === null;
  }

  clearSubmenu() {
    if (this.props.titleSubmenu) {
      this.props.clearTitleSubmenu();
    }
    if (this.props.processSubmenu) {
      this.props.clearProcessSubmenu();
    }
    if (this.props.detailSubmenu) {
      this.props.clearDetailSubmenu();
    }
  }

  handleHashChange() {
    // URL直接編集でページを変えたときに再検索を行う
    const currentPage = getPageFromQueryParam("p");
    if (this.state.currentPage !== currentPage) {
      this.handleSearch({ p: currentPage });
    }
  }

  showDropdown(name) {
    this.setState({ activeButton: name });
  }

  hideDropdown() {
    this.setState({ activeButton: "" });
  }

  showSearchPanel() {
    this.setState({ showSearchPanel: true });
  }

  hideSearchPanel() {
    this.setState({ showSearchPanel: false });
  }

  showDownloadScheduleModal() {
    this.setState({ openDownloadScheduleModal: true });
  }

  hideDownloadScheduleModal() {
    this.setState({ openDownloadScheduleModal: false });
  }

  showMiddleClassEditor(processMiddleClassId, index) {
    this.setState({
      showMiddleClassEditor: true,
      editingProcessMiddleClassId: processMiddleClassId,
      editingProcessMiddleClassIndex: index,
    });
  }

  hideMiddleClassEditor() {
    this.setState({ showMiddleClassEditor: false });
  }

  showColumnEditor(processId) {
    this.setState({
      showColumnEditor: true,
      editingProcessId: processId,
    });
  }

  showDeleteColumnDialog(process) {
    this.setState({
      showColumnDeleteDialog: true,
      deleteProcess: process,
    });
  }

  hideColumnEditor() {
    this.setState({ showColumnEditor: false });
  }

  hideDeleteColumnDialog() {
    this.setState({
      showColumnDeleteDialog: false,
      deleteProcess: null,
    });
  }

  handleDeleteProcess() {
    this.props.deleteProcess(
      this.state.deleteProcess.process_id,
      { timestamp: this.state.deleteProcess.timestamp },
      () => {
        this.handleSearch({ keepPage: true });
        this.hideDeleteColumnDialog();
      },
      () => this.hideDeleteColumnDialog()
    );
  }

  showTaskEditor(taskId, isStatus, linkageInfo) {
    this.setState({
      showTaskEditor: true,
      editingTaskId: taskId,
      isStatus: isStatus,
      linkageInfo: linkageInfo,
    });
  }

  hideTaskEditor() {
    this.setState({ showTaskEditor: false });
  }

  showItemEditor(itemId) {
    this.setState({
      editingItemId: itemId,
      showItemEditor: true,
    });
  }

  showSortEditor(itemId) {
    this.setState({
      sortItemId: itemId,
      showSortEditor: true,
    });
  }

  closeSortEditor() {
    this.setState({
      sortItemId: null,
      showSortEditor: false,
    });
  }

  hideItemEditor() {
    this.setState({ showItemEditor: false });
    this.props.removeEmptyItem();
  }

  showCreateWorkEditor(processId) {
    this.setState({
      showCreateWorkEditor: true,
      editingProcessId: processId,
    });
  }

  hideCreateWorkEditor() {
    this.setState({
      showCreateWorkEditor: false,
      editingProcessId: null,
    });
  }

  showWorkEditor(processId) {
    this.setState({
      showWorkEditor: true,
      editingProcessId: processId,
    });
  }

  hideWorkEditor() {
    this.setState({ showWorkEditor: false });
  }

  showApprovalEditor() {
    this.setState({ showApprovalEditor: true });
  }

  hideApprovalEditor() {
    this.setState({ showApprovalEditor: false });
  }

  showHelp() {
    this.setState({ showHelp: true });
  }

  hideHelp() {
    this.setState({ showHelp: false });
  }

  handleSearch(option?: { keepPage?: boolean; params?: MatrixSearchParams; hideInvalidRows?: boolean; p?: number }) {
    this.setState({
      initialSearched: true,
      start: option?.keepPage ? this.state.start : 1,
      offset: 0,
      startPos: option?.keepPage ? this.state.startPos : 1,
    });
    const params = { ...(option?.params ?? this.props.searchParams) };
    params.limit = localStorage.getItem("limit") ? parseInt(localStorage.getItem("limit")) : this.state.limit;
    params.start = option?.p
      ? calculateStartPos(option.p, this.state.limit)
      : option?.keepPage
      ? calculateStartPos(this.state.currentPage, this.state.limit)
      : 1;
    params.hideInvalidRows =
      option?.hideInvalidRows !== undefined ? option?.hideInvalidRows : !!this.props.configHideInvalidRows;

    // リスト更新後にそのまま追加ロードが走ることがあるので、
    // スクロール位置をトップに戻す
    if (this.rightBodyContainer) {
      this.rightBodyContainer.scrollTop = 0;
    }

    option?.params && this.props.setConditions(option.params);
    this.search(params, option?.keepPage);
  }

  search(params, keepPage?: boolean, retried = false) {
    const page = calculateCurrentPage(params.start, this.state.limit);
    replaceQueryParams({ p: page });
    this.props.search(this.props.isChiba, params, (data) => {
      if (!retried && data.tasks.list.length === 0 && 0 < data.tasks.total_num && data.tasks.total_num < params.start) {
        const maxPage = Math.ceil(data.tasks.total_num / this.state.limit);
        const fixedParams = { ...params, start: calculateStartPos(maxPage, this.state.limit) };
        return this.search(fixedParams, keepPage, true);
      }
      this.setState(
        {
          start: keepPage ? this.state.start : data.tasks.list.length + 1,
          end: data.tasks.list.length < this.state.limit,
          totalNum: data.tasks.total_num,
          maxPage: Math.ceil(data.tasks.total_num / this.state.limit),
          currentPage: page,
          requestParam: params,
        },
        () => {
          const urlState = restoreState();
          if (urlState.process_id) {
            scrollToProcess(urlState.process_id);

            return;
          }

          const completeProcessId = data.tasks.complete_process_id;
          if (completeProcessId) {
            scrollToProcess(completeProcessId);
          }
        }
      );
    });
  }

  handleSearchPager(startPos = 1) {
    this.setState({ isEmpty: true, startPos: startPos });
    const params = { ...this.state.requestParam };
    params.limit = this.state.limit;
    params.start = startPos;
    params.hideInvalidRows = this.props.configHideInvalidRows ? true : undefined;

    // リスト更新後にそのまま追加ロードが走ることがあるので、
    // スクロール位置をトップに戻す
    if (this.rightBodyContainer) {
      this.rightBodyContainer.scrollTop = 0;
    }
    const page = calculateCurrentPage(params.start, this.state.limit);
    replaceQueryParams({ p: page });
    this.props.search(this.props.isChiba, params, (data) => {
      this.setState(
        {
          start: data.tasks.list.length + 1,
          end: data.tasks.list.length < this.state.limit,
          maxPage: Math.ceil(data.tasks.total_num / this.state.limit),
          currentPage: page,
        },
        () => {
          const completeProcessId = data.tasks.complete_process_id;
          if (completeProcessId) {
            scrollToProcess(completeProcessId);
          }
        }
      );
    });
  }

  handleNextPage() {
    const _currentPage = this.state.currentPage;

    if (_currentPage < this.state.maxPage) {
      const startPos = 1 + _currentPage * this.state.limit;
      this.handleSearchPager(startPos);
    }
  }

  handlePrevPage() {
    const _currentPage = this.state.currentPage;

    if (_currentPage > 1) {
      const startPos = 1 + (_currentPage - 2) * this.state.limit;
      this.handleSearchPager(startPos);
    }
  }

  handleJumpPage(page) {
    const startPos = 1 + (page - 1) * this.state.limit;
    this.handleSearchPager(startPos);
  }

  syncScroll(e) {
    this.rightHeaderContainer.scrollLeft = e.target.scrollLeft;
    this.leftBodyContainer.scrollTop = e.target.scrollTop;
  }

  syncWheel(e) {
    this.rightBodyContainer.scrollTop += e.deltaY;
    this.leftBodyContainer.scrollTop += e.deltaY;
  }

  setTooltip(data) {
    this.setState({ tooltip: data });
  }

  setTooltipChiba(data) {
    this.setState({ tooltipChiba: data });
  }

  download(searchParams, filetype, format, filename) {
    const { download, toggleDownloading } = this.props;
    toggleDownloading(true);

    const params = {
      ...searchParams,
      filetype,
      format,
    };

    delete params.start;
    delete params.limit;

    const callback = (blob, filename) => {
      this.setState(
        {
          downloadUrl: URL.createObjectURL(blob),
          downloadName: filename,
        },
        () => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const evt = commonUtil.createClickEvent();
            this.btnDownload.dispatchEvent(evt);
          }
          toggleDownloading(false);
        }
      );
    };

    const fallback = () => toggleDownloading(false);
    download(params, callback, fallback);
  }

  showStatusBulkUpdatePanel(type, value) {
    this.fetchStatusUpdateNum(type);

    this.setState({
      showStatusBulkUpdate: true,
      statusBulkUpdateValue: value,
      scheduleType: type,
    });
  }

  closeStatusBulkUpdatePanel() {
    this.setState({
      showStatusBulkUpdate: false,
      statusBulkUpdateValue: null,
      loadingTaskUpdate: false,
    });
  }

  fetchStatusUpdateNum(scheduleType) {
    const callback = (res) => {
      const { total_num } = res;
      this.setState({
        statusBulkUpdateNum: total_num,
      });
    };
    this.props.fetchTaskNum(scheduleType, 1, callback, this.closeStatusBulkUpdatePanel);
  }

  handleBulkUpdate() {
    this.setState({ loadingTaskUpdate: true });
    const { bulkUpdateTaskStatus } = this.props;

    const params = {
      from_valid_flg: true,
      from_schedule_type: this.state.scheduleType,
      from_status: 0,
      from_ahead_days: 1,
      to_valid_flg: true,
      to_schedule_type: this.state.scheduleType,
      to_status: 0,
      to_ahead_days: this.state.statusBulkUpdateValue,
      to_result_end_date: null,
    };

    const callback = () => {
      this.closeStatusBulkUpdatePanel();
      this.handleSearch();
    };
    const fallback = () => {
      this.closeStatusBulkUpdatePanel();
    };
    bulkUpdateTaskStatus(params, callback, fallback);
  }

  showSpecialProcessBundle() {
    this.setState({
      showSpecialBundleEditor: true,
      bundleParams: this.props.searchParams,
    });
  }

  hideSpecialProcessBundle() {
    this.setState({ showSpecialBundleEditor: false });
  }

  showProtectionBundle() {
    this.setState({
      showProtectBundleEditor: true,
      bundleParams: this.props.searchParams,
    });
  }

  hideProtectionBundle() {
    this.setState({ showProtectBundleEditor: false });
  }

  showLimitPanel() {
    this.setState({
      isLimitPanel: true,
      tmpLimit: parseInt(localStorage.getItem("limit")) || 20,
    });
  }

  hideLimitPanel() {
    this.setState({
      isLimitPanel: false,
      tmpLimit: this.state.limit,
    });
  }

  openScreenConfigModal() {
    this.setState({ showScreenConfigModal: true });
  }

  hideScreenConfigModal() {
    this.setState({ showScreenConfigModal: false });
  }

  // 件名サブメニュー
  handleCopyItem = () => {
    if (this.props.isChiba) {
      this.props.copyItemChiba(this.props.titleSubmenu.index, this.props.titleSubmenu.item);
    } else {
      this.props.copyItem(this.props.titleSubmenu.index, this.props.titleSubmenu.item);
    }
    this.props.clearTitleSubmenu();
  };
  handleDeleteItem = () => {
    this.props.deleteItem(this.props.titleSubmenu.item.item_id, this.props.titleSubmenu.item, undefined, () =>
      this.handleSearch({ keepPage: true })
    );
    this.props.clearTitleSubmenu();
  };
  handleItemBulkOff = () => {
    this.props.bulkUpdateItemStatus(this.props.titleSubmenu.item.item_id, this.props.titleSubmenu.item, () =>
      this.handleSearch({ keepPage: true })
    );
    this.props.clearTitleSubmenu();
  };
  handleSort = (e) => {
    this.showSortEditor(this.props.titleSubmenu.item.item_id);
    this.props.clearTitleSubmenu();
    e.stopPropagation();
    e.preventDefault();
  };

  // 作業サブメニュー
  handleClickAddColumnContextMenu(e) {
    e.preventDefault();
    this.showCreateWorkEditor(this.props.processSubmenu.process.process_id);
  }

  handleClickDeleteColumnContextMenu(e) {
    e.preventDefault();
    this.showDeleteColumnDialog(this.props.processSubmenu.process);
  }

  handleClickLockColumnContextMenu(e) {
    e.preventDefault();
    this.setState({
      showColumnLockDialog: true,
      lockProcess: this.props.processSubmenu.process,
    });
  }

  hideLockColumnDialog() {
    this.setState({
      showColumnLockDialog: false,
      lockProcess: null,
    });
  }

  handleClickUnlockColumnContextMenu(e) {
    e.preventDefault();
    this.setState({
      showUnlockColumnDialog: true,
      lockProcess: this.props.processSubmenu.process,
    });
  }

  handleUnlockColumn() {
    this.props.deleteLockProcess(this.state.lockProcess.process_id, () => {
      this.hideUnlockColumnDialog();
      this.handleSearch({ keepPage: true });
    });
  }

  hideUnlockColumnDialog() {
    this.setState({
      showUnlockColumnDialog: false,
      lockProcess: null,
    });
  }

  handleClickContextMenu(e, on) {
    e.preventDefault();

    const payload = {
      on,
      column: this.props.processSubmenu.process,
      searchParams: this.props.searchParams,
    };

    this.props.bulkUpdateProcess(payload, () => {
      this.handleSearch({ keepPage: true });
    });
  }

  handleClickReceiverContextMenu(e) {
    e.preventDefault();
    this.showColumnEditor(this.props.processSubmenu.process.process_id);
  }

  handleClickSplitScheduleContextMenu(e) {
    e.preventDefault();
    this.setState({ processIdSplitScheduleModal: this.props.processSubmenu.process.process_id });
  }

  handleCloseSplitScheduleModal() {
    this.setState({ processIdSplitScheduleModal: null });
  }

  handleSave() {
    localStorage.setItem("limit", this.state.tmpLimit);
    this.setState(
      {
        isLimitPanel: false,
        limit: this.state.tmpLimit,
      },
      () => this.handleSearch()
    );
  }

  changeLimit(value) {
    this.setState({ tmpLimit: value });
  }

  render() {
    const {
      t,
      searchParams,
      rows,
      taskRoles,
      fetching,
      fetchingItemTasks,
      fetchingProcesses,
      fetchingProgressRate,
      isError,
      downloading,
      roles,
      isChiba,
    } = this.props;
    const { showStatusBulkUpdate, statusBulkUpdateValue, statusBulkUpdateNum, scheduleType } = this.state;
    const isInitialView = this.isInitialView();

    const resultProgressRate = fetchingProgressRate ? "  --  " : this.props.resultProgressRate;
    const scheduleProgressRate = fetchingProgressRate ? "  --  " : this.props.scheduleProgressRate;

    const tableTopRight = (
      <div className="tbl-top-right flex items-center">
        {!fetching && rows.length === 0 ? (
          <>
            <SettingIconButton
              className="w-[24px] p-[2px]"
              onClick={() => this.openScreenConfigModal()}
              data-test-id="matrix-button-setting"
            />
            <span
              className="icon icon-help h-[24px]"
              onClick={() => this.showHelp()}
              data-test-id="matrix-button-help"
            ></span>
          </>
        ) : (
          <>
            {!fetchingProgressRate && (
              <React.Fragment>
                {t("matrix_progress")}：{resultProgressRate}% / {scheduleProgressRate}%
                <span
                  className={`icon icon-cached ${fetchingProgressRate ? "animation-rotate-progress" : ""}`}
                  onClick={() => this.props.reloadProgressRate()}
                  data-test-id="matrix-button-reload"
                />
              </React.Fragment>
            )}
            <Spacer x="5px" />
            <SettingIconButton
              className="w-[24px] p-[2px]"
              onClick={() => this.openScreenConfigModal()}
              data-test-id="matrix-button-setting"
            />
            <span
              className="icon icon-help h-[24px]"
              onClick={() => this.showHelp()}
              data-test-id="matrix-button-help"
            ></span>
          </>
        )}
      </div>
    );

    const showBulkUpdateButton = isValid(roles, "matrix", "update");

    return (
      <div>
        <div className="contents">
          <div className="inner chiba">
            <div className="tbl-top-area mt-15 clearfix">
              <div className="tbl-top-left">
                <h1 className="page-ttl">{t("progress_manage_matrix")}</h1>
                <button
                  data-test-id="matrix-button-search-panel"
                  className="btn btn-blue btn-search w-170 mr-10"
                  onClick={() => this.showSearchPanel()}
                >
                  <i className="icon icon-search"></i>
                  {t("filter_search")}
                </button>
                <span className="item-num mr-20">
                  {t("total")}
                  {this.props.itemNum}
                  {t("unit")}
                </span>
                {!isInitialView && Boolean(rows && rows.length) && (
                  <React.Fragment>
                    <StatusSwitcher
                      value={this.props.switcherStatus}
                      onChange={(value) => this.props.changeSwitcherStatus(value)}
                      data-test-id="matrix-button-status-update"
                    />
                    {showBulkUpdateButton && (
                      <PulldownStatus showStatusBulkUpdatePanel={this.showStatusBulkUpdatePanel} />
                    )}
                    <PulldownExportContainer
                      searchParams={this.state.requestParam}
                      downloading={downloading}
                      onClickDownloadSchedule={this.showDownloadScheduleModal}
                    />
                  </React.Fragment>
                )}
              </div>

              {!isInitialView && tableTopRight}
            </div>
            {this.state.headerMessage && <div className="text-[#cc0000] my-[5px]">{this.state.headerMessage}</div>}
            {!fetching && rows.length === 0 ? (
              <React.Fragment>
                {this.state.initialSearched ? <p className="empty-message">{t("no_data")}</p> : null}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {!isInitialView && (
                  <div className={`matrix tbl-area ${fetching ? "loading loading--list" : ""}`}>
                    <div
                      className={`grid-container grid-container-progress ${isChiba ? "chiba" : ""}`}
                      // FIXME スタイル指定改善
                      style={{ height: `calc(100vh - ${this.state.headerMessage ? 177 : 154}px)` }}
                    >
                      {!fetchingItemTasks && (
                        <div className="grid-left-header">
                          {isChiba ? (
                            <LeftGridHeaderChiba
                              taskRoles={taskRoles}
                              showSpecialProcessBundle={this.showSpecialProcessBundle}
                              showProtectionBundle={this.showProtectionBundle}
                            />
                          ) : (
                            <LeftGridHeader displayRemarks={this.props.displayRemarks} />
                          )}
                        </div>
                      )}
                      {!fetchingItemTasks && (
                        <div
                          className="grid-left-body"
                          ref={(el) => (this.leftBodyContainer = el)}
                          onWheel={(e) => this.syncWheel(e)}
                        >
                          <LeftGridBody
                            rows={this.props.rows}
                            showItemEditor={(itemId) => this.showItemEditor(itemId)}
                            offset={this.state.offset}
                            maxLength={this.state.maxLength}
                            isChiba={isChiba}
                            startPos={this.state.startPos}
                            totalNum={this.state.totalNum}
                          />
                        </div>
                      )}
                      {!fetchingItemTasks && !fetchingProcesses && (
                        <div
                          className="grid-right-header"
                          ref={(el) => (this.rightHeaderContainer = el)}
                          style={{ position: "relative" }}
                        >
                          <RightGridHeaderContainer
                            columns={this.props.columns}
                            showWorkEditor={this.showWorkEditor}
                            showCreateWorkEditor={this.showCreateWorkEditor}
                            showColumnEditor={(processId) => this.showColumnEditor(processId)}
                            showDeleteDialog={(process) => this.showDeleteColumnDialog(process)}
                            showMiddleClassEditor={(processMiddleClassId, index) =>
                              this.showMiddleClassEditor(processMiddleClassId, index)
                            }
                            handleSearch={this.handleSearch}
                            rightHeaderElement={this.rightHeaderContainer}
                          />
                        </div>
                      )}
                      {!fetchingItemTasks && (
                        <div
                          className={`grid-right-body ${
                            this.props.switcherStatus !== TaskSwitcherStatus.OFF && !commonUtil.isIE()
                              ? `cursor-${this.props.switcherStatus}`
                              : ""
                          }`}
                          onScroll={(e) => this.syncScroll(e)}
                          ref={(node) => (this.rightBodyContainer = node)}
                          style={{ position: "relative" }}
                        >
                          <RightGridBody
                            rows={this.props.rows}
                            showTaskEditor={(taskId, isStatus, linkageInfo) =>
                              this.showTaskEditor(taskId, isStatus, linkageInfo)
                            }
                            setTooltip={this.setTooltip}
                            offset={this.state.offset}
                            maxLength={this.state.maxLength}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
          {this.state.maxPage > 0 && (
            <FooterPager
              currentPage={this.state.currentPage}
              maxPage={this.state.maxPage}
              onPrev={() => this.handlePrevPage()}
              onNext={() => this.handleNextPage()}
              onJump={(page) => this.handleJumpPage(page)}
              rightComponent={
                <div className="limit">
                  <span>
                    {t("limit_per_page")}
                    <a className="underline" onClick={() => this.showLimitPanel()}>
                      {this.state.limit}件
                    </a>
                  </span>
                </div>
              }
            />
          )}
        </div>

        {this.props.titleSubmenu && (
          <div
            id={`matrix-subject-contextmenu-${this.props.titleSubmenu.item.item_id}`}
            className="grid-context-menu context-menu"
            style={{ left: this.props.titleSubmenu.x, top: this.props.titleSubmenu.y }}
          >
            {this.props.titleSubmenu.canCopy && (
              <div className="menu-item" onClick={() => this.handleCopyItem()}>
                {t("copy_row")}
              </div>
            )}
            {this.props.titleSubmenu.canDelete && (
              <div className="menu-item" onClick={() => this.handleDeleteItem()}>
                {t("delete_row")}
              </div>
            )}
            {this.props.titleSubmenu.canBulkOff && (
              <div className="menu-item" onClick={() => this.handleItemBulkOff()}>
                {t("off_all_task")}
              </div>
            )}
            {this.props.titleSubmenu.canSort && (
              <div className="menu-item" onClick={(e) => this.handleSort(e)}>
                {t("sort_row")}
              </div>
            )}
          </div>
        )}

        {this.props.detailSubmenu && (
          <div
            id={`matrix-detail-contextmenu-${this.props.detailSubmenu.rowIndex}`}
            className="grid-context-menu context-menu"
            style={{ left: this.props.detailSubmenu.x, top: this.props.detailSubmenu.y }}
          >
            <div
              className={`menu-item${
                this.props.detailSubmenu.isExtraRequestDisabled ? " pointer-events-none disabled" : ""
              }`}
              onClick={() => {
                const { itemName, processName, task } = this.props.detailSubmenu ?? {};
                this.props.clearDetailSubmenu();
                this.setState({
                  showExtraRequestModal: true,
                  extraRequestTitle: itemName ?? "",
                  extraRequestProcessTitle: processName ?? "",
                  extraRequestTaskId: task?.task_id ?? null,
                });
              }}
            >
              {t("create_extra_request")}
            </div>
          </div>
        )}

        {this.props.processSubmenu && (
          <div
            id={`matrix-column-contextmenu-${this.props.processSubmenu.process?.process_id}`}
            className="context-menu"
            style={{ left: this.props.processSubmenu.x, top: this.props.processSubmenu.y }}
          >
            {/* 列挿入 */}
            {isValidRole(this.props.processSubmenu.process.roles, 5) && (
              <div
                className={clsx("menu-item", this.props.hideInvalidCols ? "pointer-events-none disabled" : "")}
                onClick={(e) => this.handleClickAddColumnContextMenu(e)}
              >
                {t("add_column")}
              </div>
            )}
            {/* 列削除 */}
            {isValidRole(this.props.processSubmenu.process.roles, 6) &&
              !this.props.processSubmenu.process.lock_flg &&
              !this.props.processSubmenu.process.key_flg && (
                <div className="menu-item" onClick={(e) => this.handleClickDeleteColumnContextMenu(e)}>
                  {t("delete_column")}
                </div>
              )}
            {/* ロック設定 */}
            {isValidRole(this.props.processSubmenu.process.roles, 9) && (
              <div
                className={clsx(
                  "menu-item",
                  this.props.processSubmenu.process.key_flg || // キー列
                    (this.props.columns ?? []).length !== this.props.unfilteredTotalNum || // 列がフィルタされている
                    this.props.hideInvalidCols // 非表示になっている作業がない列がある
                    ? "pointer-events-none disabled"
                    : ""
                )}
                onClick={(e) =>
                  this.props.processSubmenu.process.lock_flg
                    ? this.handleClickUnlockColumnContextMenu(e)
                    : this.handleClickLockColumnContextMenu(e)
                }
              >
                {this.props.processSubmenu.process.lock_flg ? t("unlock_column") : t("lock_setting")}
              </div>
            )}
            {/* 一括作業ON */}
            {isValidRole(this.props.processSubmenu.process.roles, 3) && (
              <div className="menu-item" onClick={(e) => this.handleClickContextMenu(e, true)}>
                {t("on_all_task")}
              </div>
            )}
            {/* 一括作業OFF */}
            {isValidRole(this.props.processSubmenu.process.roles, 4) && (
              <div className="menu-item" onClick={(e) => this.handleClickContextMenu(e, false)}>
                {t("off_all_task")}
              </div>
            )}
            {/* 受信者一括設定 */}
            {isValidRole(this.props.processSubmenu.process.roles, 2) && (
              <div className="menu-item" onClick={(e) => this.handleClickReceiverContextMenu(e)}>
                {t("receiver_all_task")}
              </div>
            )}
            {/* 予定表分割 */}
            {isChiba && isValidRole(this.props.processSubmenu.process.roles, 8) && (
              <div className="menu-item" onClick={(e) => this.handleClickSplitScheduleContextMenu(e)}>
                {t("split_schedule")}
              </div>
            )}
          </div>
        )}
        {this.props.processLockInfo && (
          // 明細ロック設定の情報表示（錠アイコンホバーで表示）
          <div
            id={"matrix-column-lock-keys"}
            className="absolute grid gap-[5px] bg-white p-[10px] w-[120px] border-[1px] shadow-[0_0_5px_rgba(0,0,0,0.1)] break-all"
            style={{ left: `${this.props.processLockInfo.x - 128}px`, top: `${this.props.processLockInfo.y - 55}px` }}
          >
            {this.props.processLockInfo.keyProcessNames?.map((name, index) => (
              <div key={index} className="w-full">
                {name}
              </div>
            ))}
          </div>
        )}
        {this.state.showSearchPanel && (
          <SearchPanelContainer
            search={this.handleSearch}
            cancelHandler={() => this.hideSearchPanel()}
            closeHandler={() => this.hideSearchPanel()}
          />
        )}
        {this.state.openDownloadScheduleModal && <DownloadScheduleModal onClose={this.hideDownloadScheduleModal} />}
        {this.state.showMiddleClassEditor && (
          <MiddleClassEditorContainer
            closeHandler={() => this.hideMiddleClassEditor()}
            processMiddleClassId={this.state.editingProcessMiddleClassId}
            processMiddleClassIndex={this.state.editingProcessMiddleClassIndex}
          />
        )}
        {this.state.showColumnEditor && (
          <ColumnEditorContainer
            closeHandler={() => this.hideColumnEditor()}
            handleSearch={() => this.handleSearch({ keepPage: true })}
            processId={this.state.editingProcessId}
          />
        )}
        {this.state.showTaskEditor && (
          <TaskEditorContainer
            taskId={this.state.editingTaskId}
            isStatus={this.state.isStatus}
            linkageInfo={this.state.linkageInfo}
            closeHandler={() => this.hideTaskEditor()}
          />
        )}
        {this.state.showHelp && <Help closeHandler={() => this.hideHelp()} saveHandler={() => this.hideHelp()} />}
        {this.state.showItemEditor && !isChiba && (
          <ItemEditorContainer
            itemId={this.state.editingItemId}
            displayRemarks={this.props.displayRemarks}
            closeHandler={() => this.hideItemEditor()}
          />
        )}
        {this.state.showItemEditor && isChiba && (
          <ItemEditorChibaContainer itemId={this.state.editingItemId} closeHandler={() => this.hideItemEditor()} />
        )}
        {this.state.showWorkEditor && (
          <WorkEditorContainer processId={this.state.editingProcessId} closeHandler={() => this.hideWorkEditor()} />
        )}
        {this.state.showCreateWorkEditor && (
          <WorkCreateEditorContainer
            processId={this.state.editingProcessId}
            onClose={() => this.hideCreateWorkEditor()}
            onComplete={() => this.handleSearch({ keepPage: true })}
          />
        )}
        {this.state.showColumnDeleteDialog && (
          <ConfirmDialog
            title={t("confirmation")}
            messages={[(this.state.deleteProcess?.process_name ?? "") + t("delete_confirmation"), "", t("is_it_ok")]}
            okClickHandler={() => this.handleDeleteProcess()}
            cancelClickHandler={() => this.hideDeleteColumnDialog()}
          />
        )}
        {this.state.showColumnLockDialog && (
          <LockColumnEditor
            process={this.state.lockProcess}
            processes={this.props.columns}
            onClose={() => this.hideLockColumnDialog()}
            onCompleted={() => {
              this.handleSearch({ keepPage: true });
            }}
          />
        )}
        {this.state.showUnlockColumnDialog && (
          <ConfirmDialog
            title={t("confirmation")}
            messages={[t("unlock_column_confirmation"), t("is_it_ok")]}
            okClickHandler={() => this.handleUnlockColumn()}
            cancelClickHandler={() => this.hideUnlockColumnDialog()}
          />
        )}
        {this.state.showSortEditor && (
          <SortEditor
            itemId={this.state.sortItemId}
            onClose={() => this.closeSortEditor()}
            onCompleted={() => {
              this.closeSortEditor();
              this.handleSearch({ keepPage: true });
            }}
          />
        )}
        {this.state.tooltip !== null && (
          <ReactTooltip
            id="matrix-task-detail"
            className="matrix-task-detail"
            delayShow={500}
            effect="solid"
            isCapture={true}
            scrollHide={true}
          >
            <TooltipContainer data={this.state.tooltip} />
          </ReactTooltip>
        )}
        {showStatusBulkUpdate && statusBulkUpdateNum !== 0 && (
          <Modal title={t("confirmation")} closeHandler={this.closeStatusBulkUpdatePanel}>
            <div className={`modal-body ${this.state.loadingTaskUpdate ? "loading" : ""}`}>
              <p>
                {statusBulkUpdateNum}
                {t("update_status_1")}
                {scheduleType === TaskScheduleType.SCHEDULED ? "◯" : "◎"}
                {t("update_status_2")}
                {scheduleType === TaskScheduleType.SCHEDULED && statusBulkUpdateValue === 2 ? "②" : ""}
                {scheduleType === TaskScheduleType.SCHEDULED && statusBulkUpdateValue === 3 ? "③" : ""}
                {scheduleType === TaskScheduleType.CONTINUE && statusBulkUpdateValue === 2 ? "⓶" : ""}
                {scheduleType === TaskScheduleType.CONTINUE && statusBulkUpdateValue === 3 ? "⓷" : ""}
                {t("update_status_3")}
              </p>
              <p>{t("is_it_ok")}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-gray" onClick={this.closeStatusBulkUpdatePanel}>
                {t("confirm_dismiss")}
              </button>
              <button type="button" className="btn btn-blue" onClick={this.handleBulkUpdate}>
                {t("confirm_accept")}
              </button>
            </div>
          </Modal>
        )}
        {showStatusBulkUpdate && statusBulkUpdateNum === 0 && (
          <Modal title={t("confirmation")} closeHandler={this.closeStatusBulkUpdatePanel} className="w-350 txt-center">
            <div className="modal-body">
              <p>{t("no_data_found")}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-blue" onClick={this.closeStatusBulkUpdatePanel}>
                {t("alert_ok")}
              </button>
            </div>
          </Modal>
        )}
        {this.state.showSpecialBundleEditor && (
          <SpecialProcessBundleEditorContainer
            params={this.state.bundleParams}
            itemId={this.props.paramItemId}
            handleSearch={this.handleSearch}
            closeHandler={this.hideSpecialProcessBundle}
          />
        )}
        {this.state.showProtectBundleEditor && (
          <ProtectionBundleEditorContainer
            params={this.state.bundleParams}
            itemId={this.props.paramItemId}
            handleSearch={this.handleSearch}
            closeHandler={this.hideProtectionBundle}
          />
        )}
        {this.state.isLimitPanel && (
          <Modal title={t("limit")} closeHandler={() => this.hideLimitPanel()} className="w-350 txt-center">
            <div className="modal-body">
              <div className="form-group w-200">
                <select
                  data-test-id="text-import-status"
                  className="form-control w-100"
                  value={this.state.tmpLimit}
                  onChange={(e) => this.changeLimit(Number(e.target.value))}
                >
                  <option key={1} value={10}>
                    10{t("unit")}
                  </option>
                  <option key={2} value={20}>
                    20{t("unit")}
                  </option>
                  <option key={3} value={30}>
                    30{t("unit")}
                  </option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-gray" onClick={() => this.hideLimitPanel()}>
                {t("cancel")}
              </button>
              <button type="button" className="btn btn-blue" onClick={() => this.handleSave()}>
                {t("decision")}
              </button>
            </div>
          </Modal>
        )}
        {this.state.processIdSplitScheduleModal && (
          <SegmentSettingModal
            processId={this.state.processIdSplitScheduleModal}
            categoryId={this.props.searchParams.categoryId}
            primaryChargeId={this.props.searchParams.primaryChargeId}
            onClose={() => this.handleCloseSplitScheduleModal()}
          />
        )}
        {this.state.showScreenConfigModal && (
          <MatrixScreenConfigModal
            onClose={() => this.hideScreenConfigModal()}
            isChiba={this.props.isChiba}
            onInvalidRowsFlgChanged={(hideInvalidRows) => this.handleSearch({ hideInvalidRows })}
          />
        )}
        {this.state.showExtraRequestModal && this.state.extraRequestTaskId && (
          <ExtraRequestModal
            onClose={() => this.setState({ showExtraRequestModal: false })}
            title={this.state.extraRequestTitle}
            processTitle={this.state.extraRequestProcessTitle}
            taskId={this.state.extraRequestTaskId}
          />
        )}
      </div>
    );
  }
}

Matrix.propTypes = {
  searchParams: PropTypes.object.isRequired,
  search: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  fetchingProgressRate: PropTypes.bool.isRequired,
  fetchingItemTasks: PropTypes.bool.isRequired,
  fetchingProcesses: PropTypes.bool.isRequired,
  switcherStatus: PropTypes.number.isRequired,
  columns: PropTypes.array.isRequired,
  unfilteredTotalNum: PropTypes.number.isRequired,
  rows: PropTypes.array.isRequired,
  resultProgressRate: PropTypes.number.isRequired,
  scheduleProgressRate: PropTypes.number.isRequired,
  itemNum: PropTypes.number.isRequired,
  changeSwitcherStatus: PropTypes.func.isRequired,
  removeEmptyItem: PropTypes.func.isRequired,
  reloadProgressRate: PropTypes.func.isRequired,
  download: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  validRequired: PropTypes.bool,
  isError: PropTypes.bool.isRequired,
  revertLocalCondition: PropTypes.func.isRequired,
  inheritingSearchConditions: PropTypes.bool.isRequired,
  toggleDownloading: PropTypes.func.isRequired,
  downloading: PropTypes.bool.isRequired,
  scheduleFields: PropTypes.array,
  fetchTaskNum: PropTypes.func.isRequired,
  bulkUpdateTaskStatus: PropTypes.func.isRequired,
  roles: PropTypes.object.isRequired,
  displayRemarks: PropTypes.bool.isRequired,
  titleSubmenu: PropTypes.object,
  clearTitleSubmenu: PropTypes.func.isRequired,
  constructionId: PropTypes.number,
  processSubmenu: PropTypes.object,
  clearProcessSubmenu: PropTypes.func.isRequired,
  detailSubmenu: PropTypes.object,
  clearDetailSubmenu: PropTypes.func.isRequired,
  deleteProcess: PropTypes.func.isRequired,
  bulkUpdateProcess: PropTypes.func.isRequired,
  setConditions: PropTypes.func.isRequired,
  configHideInvalidRows: PropTypes.bool,
  hideInvalidCols: PropTypes.bool,
  fetchMatrixColumnConfig: PropTypes.func.isRequired,
  copyItem: PropTypes.func.isRequired,
  copyItemChiba: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  bulkUpdateItemStatus: PropTypes.func.isRequired,
  processLockInfo: PropTypes.object,
  deleteLockProcess: PropTypes.func.isRequired,
  initializeMatrix: PropTypes.func.isRequired,
  getScheduleFields: PropTypes.func.isRequired,
};

export default withTranslation()(Matrix);

const scrollToProcess = (process_id: number) => {
  const processEl = document.querySelector(`[data-process-id="${process_id}"]`);
  const containerEl = document.querySelector(".grid-right-header");
  const bodyEl = document.querySelector(".grid-right-body");

  if (processEl && containerEl && bodyEl) {
    const processRect = processEl.getBoundingClientRect();
    const containerRect = containerEl.getBoundingClientRect();
    const diffX = processRect.x - containerRect.x;
    anime({
      targets: bodyEl,
      duration: 500,
      delay: 1500,
      easing: "cubicBezier(.09, .61, .47, 1)",
      scrollLeft: diffX - processRect.width / 2,
    });
  }
};
